import React from 'react';
import DefaultAvatar from './DefaultAvatar';

const ProfilePicture = ({ 
  photoURL, 
  userId, 
  alt, 
  className, 
  fallbackInitials, 
  size = 'medium',
  onError 
}) => {
  // Always use initials - no profile picture fetching
  if (fallbackInitials) {
    return (
      <div 
        className={`${className} profile-initials`}
        style={{
          background: 'linear-gradient(135deg, #D6A464 0%, #E6C088 50%, #F4D4A3 100%) !important',
          color: '#3B0618 !important',
          fontWeight: '700 !important',
          fontFamily: 'Montserrat, sans-serif !important',
          textTransform: 'uppercase !important',
          letterSpacing: '0.5px !important',
          boxShadow: '0 4px 16px rgba(214, 164, 100, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.3) !important',
          border: '2px solid rgba(255, 255, 255, 0.2) !important',
          textShadow: '0 1px 2px rgba(0, 0, 0, 0.2) !important',
          position: 'relative !important',
          overflow: 'hidden !important',
          display: 'flex !important',
          alignItems: 'center !important',
          justifyContent: 'center !important'
        }}
      >
        {fallbackInitials}
      </div>
    );
  }

  // Fallback to default avatar if no initials
  return (
    <DefaultAvatar 
      className={className}
      size={size}
      initials={fallbackInitials}
    />
  );
};

export default ProfilePicture;
